document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('right-drawer');
  const drawerContent = document.querySelector('.drawer-content');
  const openBtn = document.querySelector('.more-details--container');
  const closeBtn = drawer ? drawer.querySelector('.drawer-close') : null;
  const header = document.querySelector('.mega-menu-container');
  const announcementBar = document.querySelector('.announcement-bar');
  const overlay = document.getElementById('drawer-overlay');
  const toolTips = document.querySelectorAll('.hotspot');
  const swiperButtonPrev = drawer ? drawer.querySelector('.swiper-button-prev') : null;
  const swiperButtonNext = drawer ? drawer.querySelector('.swiper-button-next') : null;
  const overlayContainer = document.querySelector('.hotspot-overlay');
  const allHotspotDots = document.querySelectorAll('.hotspot-dot');

  const headerHeight = header ? header.offsetHeight : 0;

  const setHeight = () => {
    if (!drawer || !drawerContent) return;

    const isDesktop = window.innerWidth > 990;
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

    if (isDesktop) {
      const totalOffset = headerHeight + announcementHeight;
      drawer.style.marginTop = totalOffset + 'px';
      drawerContent.style.height = drawerContent.offsetHeight - totalOffset + 'px';
    } else {
      drawer.style.marginTop = '0px';
    }
  };

  const initTooltips = () => {
    const eventType = window.innerWidth > 990 ? 'mouseenter' : 'click';

    toolTips.forEach((hotspot) => {
      hotspot.addEventListener(eventType, () => {
        const hotspotText = hotspot.getAttribute('data-hotspot-text');

        if (overlayContainer) {
          overlayContainer.style.display = 'block';
          overlayContainer.querySelector('.hotspot-overlay__message').textContent = hotspotText;
          const hotspotDot = hotspot.querySelector('.hotspot-dot');
          allHotspotDots.forEach((dot) => {
            if (dot !== hotspotDot) {
              dot.style.opacity = '0.2';
            }
          });
          hotspotDot.style.opacity = '1';
          hotspotDot.style.scale = '1.3';

          const hotspotTopValue = Number(hotspot.style.top.replace('%', ''));

          if (hotspotTopValue > 35 && hotspotTopValue < 65) {
            overlayContainer.style.top = '30%';
          } else {
            overlayContainer.style.top = '50%';
          }

          // Overlap Detection
          const toolRect = overlayContainer.getBoundingClientRect();
          const prevRect = swiperButtonPrev.getBoundingClientRect();
          const nextRect = swiperButtonNext.getBoundingClientRect();

          const overPrev = !(
            toolRect.right < prevRect.left ||
            toolRect.left > prevRect.right ||
            toolRect.bottom < prevRect.top ||
            toolRect.top > prevRect.bottom
          );
          const overNext = !(
            toolRect.right < nextRect.left ||
            toolRect.left > nextRect.right ||
            toolRect.bottom < nextRect.top ||
            toolRect.top > nextRect.bottom
          );

          if (swiperButtonPrev) swiperButtonPrev.style.opacity = overPrev ? '0.1' : '1';
          if (swiperButtonNext) swiperButtonNext.style.opacity = overNext ? '0.1' : '1';
        }
      });

      hotspot.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (overlayContainer) overlayContainer.style.display = 'none';
          allHotspotDots.forEach((dot) => {
            dot.style.opacity = '0.6';
            dot.style.scale = '1';
          });
        }, 50);
      });

      if (window.innerWidth < 990) {
        const hotspotsOverlayCloseBtn = document.querySelector('.hotspot-overlay__close');

        hotspotsOverlayCloseBtn.addEventListener('click', () => {
          if (overlayContainer.style.display === 'block') {
            overlayContainer.style.display = 'none';
            allHotspotDots.forEach((dot) => {
              dot.style.opacity = '0.6';
              dot.style.scale = '1';
            });
          }
        });
      }
    });
  };

  const addEventListeners = () => {
    if (openBtn) {
      openBtn.addEventListener('click', () => {
        if (overlay) overlay.style.display = 'block';
        if (drawer) drawer.classList.add('open');
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (drawer) drawer.classList.remove('open');
        if (overlay) overlay.style.display = 'none';
      });
    }

    if (overlay) {
      overlay.addEventListener('click', () => {
        if (drawer) drawer.classList.remove('open');
        overlay.style.display = 'none';
      });
    }

    document.addEventListener('click', (e) => {
      if (drawer && openBtn && !drawer.contains(e.target) && !openBtn.contains(e.target)) {
        drawer.classList.remove('open');
        if (overlay) overlay.style.display = 'none';
      }
    });
  };

  // Initialize everything
  setHeight();
  initTooltips();
  addEventListeners();
});
